import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppDispatch } from '@/store'
import { LanguageType } from '@/constants'
import { getLocalLang } from '@/utils'
const localLang = getLocalLang()

const initialState: LanguageType = {
  label: localLang?.[0]?.label,
  lang: localLang?.[0]?.lang,
  languageType: localLang?.[0]?.languageType,
}

const languageSlice = createSlice({
  name: 'language',
  initialState: initialState,
  reducers: {
    setLanguage(state, action: PayloadAction<LanguageType>): LanguageType {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const changeLanguage = (lang: LanguageType) => (dispatch: AppDispatch) => {
  dispatch(languageSlice.actions.setLanguage(lang))
  window.localStorage.setItem('os-lang', JSON.stringify(lang))
}

export const { setLanguage } = languageSlice.actions
export default languageSlice.reducer
